import { BodyText, Icon } from '@servicetitan/design-system';
import { FC } from 'react';
import { Centered } from './centered';

export const Error: FC<{ text: string }> = ({ text }) => (
    <Centered>
        <Icon name="error" className="c-red-500 m-b-1" size={48} />
        <BodyText>{text}</BodyText>
    </Centered>
);
